import axios from "axios";

export const baseUrlApi = import.meta.env.VITE_API_URL;

export const getBackendMainUrl = baseUrlApi;
export const getAvatarsBaseUrl = `${baseUrlApi}/images/avatar`;

axios.defaults.headers.common["Content-Type"] = "application/json";
